/** Shown when no service / project name is available — never expose internal initiation IDs. */
export const VMS_UNTITLED_SERVICE_LABEL = 'Untitled service';

/** Fields that may carry the VMS service label across list/detail APIs. */
export type VmsServiceDisplayNameSource = {
  service_name?: string | null;
  serviceName?: string | null;
  service_project_name?: string | null;
  serviceProjectName?: string | null;
  vendor_display_name?: string | null;
  vendorDisplayName?: string | null;
};

/**
 * Canonical VMS service label — matches Pre Onboarding / My Tray (vendor initiation service name).
 * Falls back to FA project name, then registered vendor display name.
 *
 * When an admin updates "Name Of Service Provider" on the outsourcing register, the backend
 * syncs that value to vendor_initiations.service_name, financial_approvals.service_project_name,
 * and vms_registered_vendors.vendor_display_name so all pages stay aligned.
 */
export function resolveVmsServiceDisplayName(
  source: VmsServiceDisplayNameSource,
  fallback = ''
): string {
  const candidates = [
    source.service_name,
    source.serviceName,
    source.service_project_name,
    source.serviceProjectName,
    source.vendor_display_name,
    source.vendorDisplayName,
  ];
  for (const value of candidates) {
    const trimmed = typeof value === 'string' ? value.trim() : '';
    if (trimmed) return trimmed;
  }
  return fallback;
}

/** User-facing vendor initiation title — service name only, no `#id` suffix. */
export function vmsVendorInitiationDisplayLabel(
  serviceName?: string | null,
  fallback = VMS_UNTITLED_SERVICE_LABEL
): string {
  const trimmed = typeof serviceName === 'string' ? serviceName.trim() : '';
  return trimmed || fallback;
}
